import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { WhiteSpace } from '@/components';
import DetailGrid from './DetailGrid';
import styles from '../style/index.less';
import { jumpReport } from '@/shared/functions';
import { notification } from 'antd';
const mapStateToProps = (rootState) => ({
    carDetail: rootState.carDetail,
});
class DetailIndex extends Component {
    constructor(props) {
        super(props);
        this.linkToLevel = () => {
            const { reportUrl } = this.props.carDetail;
            if (reportUrl) {
                jumpReport(reportUrl);
            }
            else {
                notification.warn({
                    message: '暂无检测报告',
                });
            }
        };
        this.state = {};
    }
    componentWillUnmount() {
        dispatch.carDetail.resetState({});
    }
    render() {
        const { rankDesc, // 车况等级
        rankLevel, } = this.props.carDetail;
        return (<React.Fragment>
        <div className={styles.detail_header}>
          <span>车辆信息详情</span>
          <div onClick={this.linkToLevel}>
            {`查看评级${rankLevel || ''}${rankDesc || ''}`}
          </div>
        </div>
        <WhiteSpace />
        <div className={styles.detail_body}>
          {false && (<React.Fragment>
                <span>
                {`车辆编码${'-产品确认暂先隐藏'}`}
              </span>
                <div className={styles.line}/>
              </React.Fragment>)}
          <DetailGrid />
        </div>
      </React.Fragment>);
    }
}
const DetailProps = connect(mapStateToProps)(DetailIndex);
export default DetailProps;
